import React, { useEffect, useRef } from "react";

// SASS
import "./Part11.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import hospital1Img from "../../assets/img/Hospital-Setting_Phase-1.png";
import hospital2Img from "../../assets/img/Hospital-Setting_Phase-2.png";
import hospital3Img from "../../assets/img/Hospital-Setting_Phase-3.png";
import hospital4Img from "../../assets/img/Hospital-Setting_Phase-4.png";
import hospital5Img from "../../assets/img/Hospital-Setting_Phase-5.png";
import hospital6Img from "../../assets/img/Hospital-Setting_Phase-6.png";
import hospital7Img from "../../assets/img/Hospital-Setting_Phase-7.png";
import hospital8Img from "../../assets/img/Hospital-Setting_Phase-8.png";
import hospital9Img from "../../assets/img/Hospital-Setting_Phase-9.png";

// FUNCTION EXPORT
export default function Part11({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade in scene 2" },
    { stepNumber: "2", height: null, description: "fade in scene 3" },
    { stepNumber: "3", height: null, description: "fade in scene 4" },
    {
      stepNumber: "4",
      height: null,
      description: "fade in scene 5, show bed text",
    },
    {
      stepNumber: "5",
      height: null,
      description: "fade in scene 6, fade out clock text2, fade in clock text2",
    },
    {
      stepNumber: "6",
      height: null,
      description:
        "fade in scene 7, fade out clock text 2, fade in clock text3",
    },
    {
      stepNumber: "7",
      height: null,
      description: "fade in scene 8, fade in clock text3 span",
    },
    { stepNumber: "8", height: null, description: "fade in scene 9" },
    { stepNumber: "9", height: null, description: "fade in circle" },
    { stepNumber: "10", height: null, description: "spacer" },
  ];

  // REFS
  const scene1El = useRef(null);
  const scene2El = useRef(null);
  const scene3El = useRef(null);
  const scene4El = useRef(null);
  const scene5El = useRef(null);
  const scene6El = useRef(null);
  const scene7El = useRef(null);
  const scene8El = useRef(null);
  const scene9El = useRef(null);
  const clockText1El = useRef(null);
  const clockText2El = useRef(null);
  const clockText3El = useRef(null);
  const clockText3SpanEl = useRef(null);
  const bedTextEl = useRef(null);
  const circleEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(scene2El.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(scene3El.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(scene4El.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnEnter(scene5El.current, direction);
            animate.fadeInOnEnter(bedTextEl.current, direction);
            break;
          }
          case "5": {
            animate.fadeInOnEnter(scene6El.current, direction);
            animate.fadeOutOnEnter(bedTextEl.current, direction);
            animate.fadeOutOnEnter(clockText1El.current, direction);
            animate.fadeInOnEnter(clockText2El.current, direction);
            break;
          }
          case "6": {
            animate.fadeInOnEnter(scene7El.current, direction);
            animate.fadeOutOnEnter(clockText2El.current, direction);
            animate.fadeInOnEnter(clockText3El.current, direction);
            break;
          }
          case "7": {
            animate.fadeInOnEnter(scene8El.current, direction);
            animate.fadeInOnEnter(clockText3SpanEl.current, direction);
            break;
          }
          case "8": {
            animate.fadeInOnEnter(scene9El.current, direction);
            break;
          }
          case "9": {
            animate.fadeInOnEnter(circleEl.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(scene2El.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(scene3El.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(scene4El.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnExit(scene5El.current, direction);
            animate.fadeOutOnExit(bedTextEl.current, direction);
            break;
          }
          case "5": {
            animate.fadeOutOnExit(scene6El.current, direction);
            animate.fadeInOnExit(bedTextEl.current, direction);
            animate.fadeInOnExit(clockText1El.current, direction);
            animate.fadeOutOnExit(clockText2El.current, direction);
            break;
          }
          case "6": {
            animate.fadeOutOnExit(scene7El.current, direction);
            animate.fadeInOnExit(clockText2El.current, direction);
            animate.fadeOutOnExit(clockText3El.current, direction);
            break;
          }
          case "7": {
            animate.fadeOutOnExit(scene8El.current, direction);
            animate.fadeOutOnExit(clockText3SpanEl.current, direction);
            break;
          }
          case "8": {
            animate.fadeOutOnExit(scene9El.current, direction);
            break;
          }
          case "9": {
            animate.fadeOutOnExit(circleEl.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part11">
          <div className="hospital-scene-container">
            <div className="scene scene-1" ref={scene1El}>
              <img src={hospital1Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-2" ref={scene2El}>
              <img src={hospital2Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-3" ref={scene3El}>
              <img src={hospital3Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-4" ref={scene4El}>
              <img src={hospital4Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-5" ref={scene5El}>
              <img src={hospital5Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-6" ref={scene6El}>
              <img src={hospital6Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-7" ref={scene7El}>
              <img src={hospital7Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-8" ref={scene8El}>
              <img src={hospital8Img} alt="" className="img-fluid" />
            </div>
            <div className="scene scene-9" ref={scene9El}>
              <img src={hospital9Img} alt="" className="img-fluid" />
            </div>
            <div className="text clock-text clock-text-1" ref={clockText1El}>
              In hospitals, it is important to wait for the contact time to
              finish before using a surface.
            </div>
            <div className="text clock-text clock-text-2" ref={clockText2El}>
              You want to get your patients in and out quickly.
            </div>
            <div className="text clock-text clock-text-3" ref={clockText3El}>
              So you may feel pressure to move fast.
              <br />{" "}
              <span className="line-2" ref={clockText3SpanEl}>
                However, <b>the risk of spreading germs is greater.</b>
              </span>
            </div>
            <div className="text bed-text" ref={bedTextEl}>
              This can be hard.
            </div>
          </div>
          <div className="circle" ref={circleEl}></div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
